import {CubeState} from "../Models/CubeState";
import HttpService from "./HttpService";

export class CubeStateService
{
  public static async getState(id: string): Promise<CubeState>
  {
    const url = `/Cube/Status/${id}`;
    
    return HttpService.get<CubeState>(url);
  }
}